
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $deb74c52fb917601$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"eAoW7\",\"RelatedLinksModal.289910ee.js\",\"i4cia\",\"component-lazy.bc9d9581.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.fb22b227.js\",\"gabkQ\",\"component-lazy.3be5b2f4.js\",\"hogcU\",\"component-lazy.c401bc70.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.d0ac37f3.js\",\"28arV\",\"component-lazy.c131e274.js\",\"ffEVr\",\"vendors~editor_icon.d6c392c9.js\",\"kDqHr\",\"file-icon.7c0a9b34.js\",\"6wr18\",\"vendors~editor_icon.181a3fa4.js\",\"4HZlX\",\"chart-bar-icon.6975ba0a.js\",\"7jSfd\",\"list-bullet-icon.339b1061.js\",\"kNV5Y\",\"blog.3e99625c.js\",\"dek7I\",\"page-live-doc.e1fb948c.js\",\"aOY32\",\"branch.39841ed7.js\",\"6fQco\",\"commit.db49daa6.js\",\"1MWOL\",\"pull-request.4fb04de2.js\",\"9wPDc\",\"code.202cf95c.js\",\"9atVd\",\"bug.be04cdf7.js\",\"lm9Lt\",\"changes.07688104.js\",\"jiFtb\",\"epic.b1fbdda3.js\",\"4S1SF\",\"incident.1e46f757.js\",\"XZauT\",\"problem.9af02f8c.js\",\"3MYQs\",\"work-item.ee7b4cf1.js\",\"5zapo\",\"story.df2861de.js\",\"9aQIt\",\"subtask.72d6860d.js\",\"6SWFK\",\"task.38634381.js\",\"hv4mn\",\"component-lazy.831adb08.js\",\"76qVV\",\"component-lazy.b6bb5924.js\",\"jYV57\",\"component-lazy.runtime.c26f75df.js\",\"4SCW2\",\"component-lazy.9b67e0a9.js\",\"6iz6l\",\"component-lazy.runtime.485d7194.js\",\"etEYy\",\"manual-triggers-modal.06c1c832.js\",\"jYV57\",\"component-lazy.runtime.c26f75df.js\",\"6iz6l\",\"component-lazy.runtime.485d7194.js\",\"kO0mz\",\"audio-icon.1d4ed522.js\",\"jDjSj\",\"16.1d00245e.js\",\"gQLjx\",\"angle-brackets-icon.7405e6b4.js\",\"5i5pX\",\"folder-icon.3ad4b9d8.js\",\"eA5B3\",\"image-icon.2aaa4f7d.js\",\"7AsyI\",\"video-icon.34dc59f6.js\",\"jNyUd\",\"component.30faa9cf.js\",\"2fk6g\",\"16.54cd560a.js\",\"huUvS\",\"16.95572e52.js\",\"1oiJ6\",\"16.f20e72ef.js\",\"lxiFd\",\"16.6f66d48d.js\",\"eDqo1\",\"16.775f562b.js\",\"6HBYC\",\"16.e6a8a945.js\",\"bYxCZ\",\"16.1d6e89c2.js\",\"eTBsW\",\"16.a21a1ba3.js\",\"020xd\",\"16.4d1d2449.js\",\"ls0Um\",\"16.cbe8174e.js\",\"eVYW1\",\"16.71a0c4aa.js\",\"f35QR\",\"16.4bd4939d.js\",\"87j6O\",\"jira-icon.eb7336b7.js\",\"lQhaj\",\"priority-blocker-icon.788e81c1.js\",\"iEn0J\",\"priority-critical-icon.83e6abbc.js\",\"d2etG\",\"priority-high-icon.66f03968.js\",\"2rWNg\",\"priority-highest-icon.da70d813.js\",\"akInk\",\"priority-low-icon.337ea45b.js\",\"6zoNk\",\"priority-lowest-icon.bdd817e7.js\",\"1MCFU\",\"priority-major-icon.5ccf213d.js\",\"gz7jV\",\"priority-medium-icon.86c1e72f.js\",\"5Bj6b\",\"priority-minor-icon.01049963.js\",\"89ync\",\"priority-trivial-icon.caeede3d.js\",\"3wY4G\",\"goal-icon.d7d5cbdd.js\",\"88r9N\",\"projects-icon.8276c4d7.js\",\"cqZpg\",\"manual-triggers-modal.030d896a.js\",\"7EorR\",\"vendors~editor_atlaskit_md.af913115.js\",\"kHOMt\",\"manual-triggers-modal.63f58b3c.js\",\"aoU9B\",\"RelatedLinksModal.cacc0247.js\",\"kDLrp\",\"EmbedModal.8f473bf8.js\",\"bFS2f\",\"fullscreen-exit.193e24d3.js\"]"));


$parcel$global.rlb("9Tc4b")
//# sourceMappingURL=RelatedLinksModal.runtime.ded35f3a.js.map
